
import Input from '../input/Input';
import Select from '../select/Select';
import Button from '../buttons/Button';
import './registrationDonorDetails.css';
import RegistrationUnitsSummary from '../registrationUnitsSummary/RegistrationUnitsSummary';
import RegistrationTerms from '../registrationTerms/RegistrationTerms';
import { useContext } from 'react';
import { appContext } from '../../service/AppContext';
import { registrationContex } from '../../service/RegisrationContext';
import { formatNumber, getPersonIdValidation } from '../../service/inputUtil';
import { useState } from 'react';
import DatePicker from '../datePicker/DatePicker';
import { useFetch } from '../../service/useFetch';

export default function RegistrationDonorDetails({ onCompleted }) {

    const { isPending, setFetch, urlAgent } = useContext(appContext)
    const { completedKids, donor, setDonor, signed, setSigned, agent } = useContext(registrationContex)


    const [donorIdValidation, setDonorIdValidation] = useState(getDonorIdValidationMessage)
    const [spouseIdValidation, setSpouseIdValidation] = useState(getSpouseIdValidationMessage)

    const { data: agents } = useFetch('/agents');



    function getDonorIdValidationMessage() {
        if (!donor?.personId)
            return { invalid: false, errorText: '' }
        let personIdValidation = getPersonIdValidation(donor.personId)
        if (!personIdValidation.invalid && (completedKids?.some(kid => kid.idType === 'Person_Id' && kid.personId === donor.personId) || donor.personId === donor.spousePersonId)) {
            personIdValidation = { invalid: true, errorText: 'ת.ז כבר בשימוש' }
        }
        return personIdValidation
    }

    function getSpouseIdValidationMessage() {
        if (!donor?.spousePersonId)
            return { invalid: false, errorText: '' }
        let personIdValidation = getPersonIdValidation(donor.spousePersonId)
        if (!personIdValidation.invalid && (completedKids?.some(kid => kid?.idType === 'Person_Id' && kid.personId === donor.spousePersonId) || donor.personId === donor.spousePersonId)) {
            personIdValidation = { invalid: true, errorText: 'ת.ז כבר בשימוש' }
        }
        return personIdValidation
    }

    function validateSigned() {
        let valid = true;
        if (signed.joining === false) {
            valid = false;
            setSigned(prev => { return { ...prev, joiningInvalid: true } })
        }
        if (signed.interest === false) {
            valid = false;
            setSigned(prev => { return { ...prev, interestInvalid: true } })
        }
        return valid;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const formElement = e.target;
        let signValidity = validateSigned();
        const isValid = formElement.checkValidity() && (donor.idType !== 'Person_Id' || !donorIdValidation.invalid) && signValidity;
        formElement.classList.add('submitted');

        if (isValid) {
            if (!isPending) {
                setFetch({
                    route: '/unit-request',
                    options: {
                        method: 'POST',
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            id: donor?.id,
                            urlAgent,
                            donor,
                            kids: completedKids?.map(kid => { return { ...kid, plan: kid.plan?.route, planName: kid.plan?.title, familyPlan: !!kid.plan?.unitPlans } }),
                            joiningSignature: signed.joiningSignature,
                            interestSignature: signed.interestSignature
                        })
                    }
                })
                if (typeof (onCompleted) === 'function')
                    onCompleted(e);
            }
        }
        else {
            const firstInvalidField = formElement.querySelector(":invalid");

            if (firstInvalidField) {
                firstInvalidField?.scrollIntoView({ behavior: "smooth", block: "center" });
                setTimeout(() => { firstInvalidField?.focus(); }, 400);
            }
            else if (donorIdValidation?.invalid) {
                let donorIdField = formElement.querySelector('#person-id');
                if (donorIdField) {
                    donorIdField?.scrollIntoView({ behavior: "smooth", block: "center" })
                    setTimeout(() => { donorIdField?.focus(); }, 400);
                }
            }
            else if (signed.joining === false || signed.interest === false) {

                let termsContainer = formElement.querySelector('.terms-container');
                if (termsContainer) {

                    termsContainer?.scrollIntoView({ behavior: "smooth", block: "center" })
                    setTimeout(() => { termsContainer?.focus(); }, 400);
                }
            }
        }

    }


    const HandleUpdateDonorCB = (key) => {
        if (['houseNumber', 'apartmentNumber'].includes(key)) return updateNumber
        if (key === 'phone') return updatePhoneNumber
        if (['mobile', 'spousePhone'].includes(key)) return updateMobilePhoneNumber
        if (key === 'personId') return updateId
        if (key === 'spousePersonId') return updateSpouseId

        return updateDonorKey


        function updateNumber(value) {
            value = formatNumber(value);
            updateDonorKey(value);
        }
        function updatePhoneNumber(value) {
            value = formatNumber(value, { allowDesh: true });
            updateDonorKey(value);
        }

        function updateMobilePhoneNumber(value) {
            value = formatNumber(value, { maxLength: 10, partLength: 3, repeat: false });
            updateDonorKey(value);
        }
        function updateId(value) {
            value = formatNumber(value);
            let personIdValidation = getPersonIdValidation(value)
            if (!personIdValidation.invalid && (completedKids?.some(kid => kid?.idType === 'Person_Id' && kid.personId === value) || value === donor.spousePersonId)) {
                personIdValidation = { invalid: true, errorText: 'ת.ז כבר בשימוש' }
            }
            setDonorIdValidation(personIdValidation)
            updateDonorKey(value);
        }
        function updateSpouseId(value) {
            value = formatNumber(value);
            let personIdValidation = getPersonIdValidation(value)
            if (!personIdValidation.invalid && (completedKids?.some(kid => kid?.idType === 'Person_Id' && kid.personId === value) || value === donor.personId)) {
                personIdValidation = { invalid: true, errorText: 'ת.ז כבר בשימוש' }
            }
            if (value === "")
                personIdValidation = { invalid: false, errorText: '' }
            setSpouseIdValidation(personIdValidation)
            updateDonorKey(value);
        }

        function updateDonorKey(value) {
            setDonor(prev => { return { ...prev, [key]: value } })
        }

    }


    return (
        <div className="donor-details card-content-wrapper">
            <form onSubmit={handleSubmit} noValidate>
                <div className='details-wrapper'>
                    <div className='donor-info'>
                        <div role="heading" aria-level="2" className='heading-h3' >מלאו את הפרטי ההורה/התורם</div >
                        <div className="fields-flex">
                            <Input className='first-name' value={donor.firstName} onChange={HandleUpdateDonorCB('firstName')} type='text' name='first-name' id='first-name' label='שם פרטי' required />
                            <Input className='last-name' value={donor.lastName} onChange={HandleUpdateDonorCB('lastName')} type='text' name='last-name' id='last-name' label='שם משפחה' required />
                            <Select className="id-type" value={donor.idType} onChange={HandleUpdateDonorCB('idType')} name='id-type' id='id-type' label='אמצעי זיהוי' >
                                <option value="Person_Id">תעודת זהות</option>
                                <option value="Passport_Id">דרכון</option>
                            </Select>
                            {(donor.idType === 'Person_Id') &&
                                <Input value={donor.personId} onChange={HandleUpdateDonorCB('personId')} type='text' name='person-id' id='person-id' label='תעודת זהות' required maxlength={9} invalid={donorIdValidation?.invalid} errorText={donorIdValidation?.errorText} />
                            }
                            {(donor.idType === 'Passport_Id') &&
                                <Input value={donor.passportId} onChange={HandleUpdateDonorCB('passportId')} type='text' name='passport-id' id='passport-id' label='דרכון' required />
                            }
                            <DatePicker label="תאריך לידה" className="donor-birthday" name="donor-birthday" value={donor.birthday} onChange={HandleUpdateDonorCB('birthday')} max={new Date().toJSON().slice(0, 10)} required />

                            <Input value={donor.email} onChange={HandleUpdateDonorCB('email')} type='email' name='mail' id='mail' label='כתובת דוא"ל' required pattern="\w+(.+\w+)?@\w+(\.\w+)+" />
                            <Input value={donor.phone} onChange={HandleUpdateDonorCB('phone')} type='tel' name='phone' id='phone' label='טלפון בבית' pattern="[0-9]{2,3}-?[0-9]{7}" maxlength={/-/.test(donor.phone) ? 11 : 10} />
                            <Input value={donor.mobile} onChange={HandleUpdateDonorCB('mobile')} type='tel' name='mobile' id='mobile' label='טלפון נייד' pattern="[0-9]{3}-?[0-9]{7}" maxlength={/-/.test(donor.mobile) ? 11 : 10} required />

                            <Input className='city' value={donor.city} onChange={HandleUpdateDonorCB('city')} type='text' name='city' id='city' label='עיר' required />
                            <Input className='street' value={donor.street} onChange={HandleUpdateDonorCB('street')} type='text' name='street' id='street' label='רחוב' required />
                            <Input className='house-number' value={donor.houseNumber} onChange={HandleUpdateDonorCB('houseNumber')} type='text' name='house-number' id='house-number' label='מספר בית' pattern="[0-9]*" required />
                            <Input className='apartment-number' value={donor.apartmentNumber} onChange={HandleUpdateDonorCB('apartmentNumber')} type='text' name='apeartment-number' id='apeartment-number' label='מספר דירה' pattern="[0-9]*" />

                            <Input className='spouse-name' value={donor.spouseName} onChange={HandleUpdateDonorCB('spouseName')} type='text' name='spouse-name' id='spouse-name' label='שם ב. הזוג' />
                            <DatePicker label="תאריך לידה ב. הזוג" className="spouse-birthday" name="spouse-birthday" value={donor.spouseBirthday} onChange={HandleUpdateDonorCB('spouseBirthday')} max={new Date().toJSON().slice(0, 10)} />
                            <Select className="spouse-id-type" value={donor.spouseIdType} onChange={HandleUpdateDonorCB('spouseIdType')} name='spouse-id-type' id='spouse-id-type' label='אמצעי זיהוי ב. הזוג' >
                                <option value="Person_Id">תעודת זהות</option>
                                <option value="Passport_Id">דרכון</option>
                            </Select>
                            {(donor.spouseIdType === 'Person_Id') &&
                                <Input value={donor.spousePersonId} onChange={HandleUpdateDonorCB('spousePersonId')} type='text' name='spouse-person-id' id='spouse-person-id' label='תעודת זהות ב. הזוג' maxlength={9} invalid={spouseIdValidation?.invalid} errorText={spouseIdValidation?.errorText} />
                            }
                            {(donor.spouseIdType === 'Passport_Id') &&
                                <Input value={donor.spousePassportId} onChange={HandleUpdateDonorCB('spousePassportId')} type='text' name='spouse-passport-id' id='spouse-passport-id' label='דרכון ב. הזוג' />
                            }
                            <Input value={donor.spousePhone} onChange={HandleUpdateDonorCB('spousePhone')} type='tel' name='spouse-phone' id='spouse-phone' label='טלפון ב. הזוג' pattern="[0-9]{3}-?[0-9]{7}" maxlength={/-/.test(donor.spousePhone) ? 11 : 10} />
                            <Input value={donor.spouseEmail} onChange={HandleUpdateDonorCB('spouseEmail')} type='email' name='spouse-mail' id='spouse-mail' label='כתובת דוא"ל ב. הזוג' pattern="\w+(.+\w+)?@\w+(\.\w+)+" />

                            <Select value={donor.sector} onChange={HandleUpdateDonorCB('sector')} name="sector" label='מגזר'  >
                                <option value="Hasidic">חסידי</option>
                                <option value="Litayi">ליטאי</option>
                                <option value="Sfaradi">ספרדי</option>
                            </Select>
                            <Select value={donor.occupation} onChange={HandleUpdateDonorCB('occupation')} name="occupation" label='עיסוק'  >
                                {/* אברך, שכיר , עצמאי */}
                                <option value="Yeshiva Student">אברך</option>
                                <option value="Employee">שכיר</option>
                                <option value="Self Employed">עצמאי</option>
                            </Select>

                            <Select label='נציג' value={donor.agent} onChange={HandleUpdateDonorCB('agent')} name='agent' required options={agents} locked={donor.agent && agents?.some(agent => agent.value === donor.agent) && agent} />

                            <Select value={donor.callSource} onChange={HandleUpdateDonorCB('callSource')} name="callSource" label='איך הגעת אלינו?'  >
                                <option value="Country Paper">פרסום בעיתון</option>
                                <option value="Local Paper">פרסום במקומון</option>
                                <option value="Advertising">פרסום חוצות</option>
                                <option value="Agent">נציג</option>
                                <option value="Site">אתר</option>
                                <option value="Other">אחר</option>
                            </Select>
                            {(donor.callSource === 'Other') && <Input value={donor.otherSource} onChange={HandleUpdateDonorCB('otherSource')} type='text' name='other-source' id='other-source' label='מקור הגעה' />
                            }
                        </div>
                        <div className="comma-notes">* שדות חובה</div>
                        <div className="is-member" role='radiogroup'>
                            <div role="heading" aria-level="3" className='heading-h4'>האם אתה חבר בגמ"ח</div >
                            <div className="radio-wrapper">
                                <label htmlFor="member"><input type="radio" name="is-member" id="member" checked={donor.isMember} onChange={(e) => HandleUpdateDonorCB('isMember')(true)}  required/>אני חבר בגמ"ח המרכזי</label>
                                <label htmlFor="not-member"><input type="radio" name="is-member" id="not-member" checked={donor.isMember === false} onChange={(e) => HandleUpdateDonorCB('isMember')(false)} required />אני עדיין לא חבר בגמ"ח המרכזי</label>
                                 <div className='validation-message' >חובה לבחור</div>
                            </div>
                        </div>
                        <hr className='card-hr hr-middle' />
                    </div>
                    <RegistrationUnitsSummary />
                    <RegistrationTerms />
                    <Button label='מעבר לתשלום' />
                </div>
            </form>
        </div>
    )
}

